module.exports = __webpack_public_path__ + "packs/media/images/Silvie-fc7c0725c018ac1c4f57c24950df5850.jpg";